
























import { defineComponent } from "@vue/composition-api";
import TextFilter from "@monorepo/uikit/src/components/tableViews/TextFilter.vue";

export default defineComponent({
  components: {
    TextFilter,
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    treeItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: false,
      treeOpen: [],
      currentValue: null as Record<string, unknown>[] | null,
    };
  },
  computed: {
    selectedItemsString: {
      get(): string {
        return (
          (this.value || [])
            .slice(0, 5)
            .map((item) => (item as Record<string, unknown>).name)
            .join(", ") || ""
        );
      },
      set(value: string) {
        if (!value) {
          this.$emit("change", []);
        }
      },
    },
  },
  methods: {
    showModal() {
      this.dialogVisible = true;
    },
    closeModal() {
      this.dialogVisible = false;
    },
    saveSelection() {
      this.$emit("change", this.currentValue || this.value || []);
      this.closeModal();
    },
    changeTree(value: Record<string, unknown>[]) {
      this.currentValue = [...(value || [])];
    },
  },
});
